import React from 'react'
import _isString from 'lodash/isString'
import { makeIcon, IconName } from './icons/index'

interface OracleIconButtonProps {
  icon: IconName
  invert?: boolean
  border?: 'none' | 'circle' | 'square'
  shape?: 'circle' | 'square'
  'aria-label'?: string
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  className?: string
  size?: string
  disabled?: boolean
}

const OracleIconButton: React.FC<OracleIconButtonProps> = ({
  icon,
  invert = false,
  border = 'none',
  shape = 'circle',
  'aria-label': ariaLabel,
  onClick,
  type = 'button',
  className = '',
  size,
  disabled = false,
}) => {
  const baseClass = 'oracle-icon-button'
  const safeClassName = _isString(className) ? className : ''
  const invertClass = invert ? `${baseClass}--inverted` : ''
  const borderClass = border !== 'none' ? `${baseClass}--border-${border}` : ''
  const shapeClass = shape === 'square' ? `${baseClass}--square` : ''
  const combinedClassName = `${baseClass} ${invertClass} ${borderClass} ${shapeClass} ${safeClassName}`.trim()

  return (
    <button
      type={type}
      className={combinedClassName}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
    >
      {makeIcon(icon, size)}
    </button>
  )
}

export default OracleIconButton
